import { Stack, Text } from '@mantine/core';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type {
  FilterState,
  FuelCategoryThresholds,
} from '@/features/filterSlice';
import { FuelCategoryBucket } from '@/generated/types/navigator/types.gen';
import { FUEL_CATEGORY_MESSAGE_IDS } from '@/features/wildfireSlice';
import { useClientTerminology } from '@/views/list/NetworkTerms';

const CATEGORY_KEYS = Object.keys(FUEL_CATEGORY_MESSAGE_IDS) as Array<
  keyof FuelCategoryThresholds
>;

export const FuelDistributionFilter = (props: {
  control: Control<FilterState>;
}) => {
  const intl = useClientTerminology();

  const noConstraintLabel = intl.formatMessage({
    id: 'filter.fuelDistribution.noConstraint',
  });

  const fuelBucketOptions = [
    { value: FuelCategoryBucket.LESS_THAN_5, label: '0-5%' },
    { value: FuelCategoryBucket['6_TO_25'], label: '6-25%' },
    { value: FuelCategoryBucket['26_TO_50'], label: '26-50%' },
    { value: FuelCategoryBucket['51_TO_75'], label: '51-75%' },
    { value: FuelCategoryBucket.MORE_THAN_75, label: '76-100%' },
  ];

  return (
    <Stack gap="xs">
      <Text c="var(--os-mainColor-foreground-secondary)">
        {intl.formatMessage({ id: 'filter.fuelDistribution.title' })}
      </Text>
      {CATEGORY_KEYS.map((category) => (
        <Controller
          key={category}
          control={props.control}
          name={`fuelCategoryThresholds.${category}` as const}
          render={({ field: { onChange, onBlur, value } }) => (
            <InputSelect
              isMulti
              onChange={onChange}
              onBlur={onBlur}
              value={fuelBucketOptions.filter((o) => value.includes(o.value))}
              maxMenuHeight={150}
              label={intl.formatMessage({
                id: FUEL_CATEGORY_MESSAGE_IDS[category],
              })}
              placeholder={noConstraintLabel}
              options={fuelBucketOptions}
            />
          )}
        />
      ))}
    </Stack>
  );
};
